const isTouchable = 'ontouchstart' in document.documentElement;
let moved = false;
let touchedObject = null;

export function onClickHandler(handler, isDisabled = false) {
    return {
        onTouchStart: (e) => {
            touchedObject = e.target;
        },
        onTouchMove: (e) => {
            moved = true;
        },
        onTouchEnd: (e) => {
            if (moved) {
                moved = false;
                return;
            }
            if (!isTouchable || isDisabled) {
                return;
            }

            if (e.target !== touchedObject) {
                return;
            }
            if (handler) {
                handler(e);
                e.preventDefault();
            }
        },
        onClick: (e) => {
            if (isTouchable || isDisabled) {
                return;
            }
            if (handler) {
                handler(e);
            }
        },
    };
}